<div class="p-4 md:p-6 max-w-6xl mx-auto">
  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center mb-6">
    <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
    Cuentas Activas
    <span *ngIf="dataSource" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ dataSource.data.length }} cuentas
    </span>
  </h1>
  <span *ngIf="dataSource" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ dataSource.data.length }} cuentas
  </span>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="dataSource">
    <div class="overflow-x-auto">
      <mat-table [dataSource]="dataSource">
        <!-- ID -->
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef style="min-width: 70px; max-width: 80px;">Id</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 70px; max-width: 80px;">
            <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">{{ row.id }}</span>
          </mat-cell>
        </ng-container>

        <!-- Banco -->
        <ng-container matColumnDef="banco">
          <mat-header-cell *matHeaderCellDef style="min-width: 180px;">Banco</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 180px;">
            <span class="text-xs font-semibold text-gray-700">{{ row.banco }}</span>
          </mat-cell>
        </ng-container>

        <!-- Cuenta -->
        <ng-container matColumnDef="cuenta">
          <mat-header-cell *matHeaderCellDef style="min-width: 130px;">Cuenta</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 130px;">
            <span class="text-xs text-gray-600">{{ row.cuenta }}</span>
          </mat-cell>
        </ng-container>

        <!-- Numero de Cuenta -->
        <ng-container matColumnDef="numeroCuenta">
          <mat-header-cell *matHeaderCellDef style="min-width: 140px;">Número de Cuenta</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 140px;">
            <span class="text-xs font-mono text-gray-700">{{ row.numeroCuenta }}</span>
          </mat-cell>
        </ng-container>

        <!-- Tipo de Cuenta -->
        <ng-container matColumnDef="tipoCuenta">
          <mat-header-cell *matHeaderCellDef style="min-width: 120px;">Tipo de Cuenta</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 120px;">
            <span class="text-xs text-gray-600">{{ formatRut(row.tipoCuenta) }}</span>
          </mat-cell>
        </ng-container>

        <!-- Rut -->
        <ng-container matColumnDef="rutemisor">
          <mat-header-cell *matHeaderCellDef style="min-width: 130px;">Rut</mat-header-cell>
          <mat-cell *matCellDef="let row" style="min-width: 130px;">
            <span class="text-xs font-mono text-gray-700">{{ formatRut(row.rutemisor) }}</span>
          </mat-cell>
        </ng-container>

        <!-- Acciones (Disponibilidad) -->
        <ng-container matColumnDef="acciones" stickyEnd>
          <mat-header-cell *matHeaderCellDef style="min-width: 160px; max-width: 200px; text-align: center;">Disponibilidad</mat-header-cell>
          <mat-cell *matCellDef="let element" style="min-width: 160px; max-width: 200px; text-align: center;">
            <mat-slide-toggle
              [checked]="element.disponible === true"
              (change)="updateAccountStatus(element.id, $event.checked ? true : false)"
              color="primary">
              {{ element.disponible === true ? 'Disponible' : 'No disponible' }}
            </mat-slide-toggle>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let element of dataSource.data"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === element.id ? '#1C593D' : '#e5e7eb'">

      <!-- Card header (siempre visible) -->
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(element.id)"
        [style.background]="expandedCardId === element.id ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">#{{ element.id }}</span>
          <span class="text-sm font-semibold text-gray-800 truncate">{{ element.banco }}</span>
          <span class="px-2 py-0.5 text-xs font-bold rounded-full shrink-0"
            [style.background]="element.disponible ? '#dcfce7' : '#fee2e2'"
            [style.color]="element.disponible ? '#16a34a' : '#dc2626'">
            {{ element.disponible ? 'Disponible' : 'No disponible' }}
          </span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === element.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Card body (expandible) -->
      <div *ngIf="expandedCardId === element.id" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cuenta</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ element.cuenta }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Número de Cuenta</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ element.numeroCuenta }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo de Cuenta</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ formatRut(element.tipoCuenta) }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Rut</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ formatRut(element.rutemisor) }}</p>
          </div>
        </div>
        <!-- Toggle disponibilidad -->
        <div class="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
          <span class="text-xs font-semibold text-gray-500">Disponibilidad</span>
          <mat-slide-toggle
            [checked]="element.disponible === true"
            (change)="updateAccountStatus(element.id, $event.checked ? true : false)"
            color="primary">
            {{ element.disponible === true ? 'Disponible' : 'No disponible' }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
</div>
